import { useEffect } from 'react'
import { usePaymentIframe } from '@/shared/hooks/use-payment-iframe'
import { useIsOffline } from '@/shared/hooks/use-is-offline'
import { useIframeVisibility } from '@/shared/context/iframe-visibility-context'
import { PRODUCT } from '@/shared/constants/product'

export function usePaymentInUpdatePage(
  isVisible: boolean = true,
  onClose?: () => void,
) {
  const isOffline = useIsOffline()
  const { setPayInOpen, closeHandlerRef } = useIframeVisibility()

  useEffect(() => {
    setPayInOpen(isVisible && !isOffline)
    return () => setPayInOpen(false)
  }, [isVisible, isOffline, setPayInOpen])

  useEffect(() => {
    closeHandlerRef.current = onClose
    return () => {
      closeHandlerRef.current = undefined
    }
  }, [onClose, closeHandlerRef])

  return {
    ...usePaymentIframe(PRODUCT.PORTAL),
    isOffline,
  }
}
